import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

fun filterStatEvent(games: List<StatGame>, selectedEvent: String?): List<StatGame> =
    if (selectedEvent == null) games else games.filter { it.eventKey() == selectedEvent }

@Composable
fun StatEventFilter(games: List<StatGame>, names: Map<String, String>, selectedEvent: String?, onSelect: (String?) -> Unit) {
    Div(attrs = { classes("filter-group", "stat-event-filter") }) {
        Span(attrs = { classes("filter-label") }) { Text("Událost") }
        Select(attrs = {
            classes("field")
            attr("aria-label", "Událost")
            onChange { onSelect(it.value?.ifBlank { null }) }
        }) {
            Option("", attrs = { if (selectedEvent == null) selected() }) { Text("Souhrn") }
            games.groupBy { it.eventKey() }.values.sortedWith(
                compareByDescending<List<StatGame>> { it.first().date ?: "" }.thenBy { it.first().refId }
            ).forEachIndexed { index, event ->
                val g = event.first()
                Option(g.eventKey(), attrs = { if (selectedEvent == g.eventKey()) selected() }) {
                    val players = event.map { names[it.playerId] ?: it.playerId }.distinct().joinToString(", ")
                    Text("${g.date ?: "Bez data"} · ${sourceLabelSingular(g.source)}${g.round?.let { " · $it. kolo" } ?: ""} · $players · #${index + 1}")
                }
            }
        }
    }
}
